module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"navigate":"Ativar conta","validation":"Validação","personalization":"Personalização","concluded":"Concluído","alert-qrcode":"Não foi possível criar o QR Code. Tente outra vez."},"en-US":{"navigate":"Activate account","validation":"Validation","personalization":"Personalization","concluded":"Concluded","alert-qrcode":"Could not create qr code. Try again."}}')
  delete Component.options._Ctor
}
